import Button from 'components/Button/Button'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const ClientProfileFormContainer = styled.div`
  width: 995px;
  height: 100%;
  border-radius: 15px;
  border: 1px solid #e5e5e5;
  box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.2);
  -webkit-box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.2);
`

export const ClientProfileFormHeaderContainer = styled.div`
  padding-left: 39px;
  margin-top: 48px;
  display: flex;
  align-items: center;
`

export const ClientProfileFormTitle = styled.h6`
  margin: 0;
  font-weight: bold;
  font-size: 28px;
  line-height: 28px;
  color: ${({ theme }) => theme.colors.blackSecondary};
`
export const ClientProfileFormViewProfile = styled(Link)`
  margin: 0;
  margin-left: 25px;
  font-size: 12px;
  line-height: 130%;
  text-decoration-line: underline;
  color: ${({ theme }) => theme.colors.primary};
`

export const ClientProfileFormUserContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-left: 39px;
  margin-right: 82px;
`
export const ClientProfileFormUContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const ClientProfileFormUser = styled.p`
  margin: 0;
  font-size: 16px;
  line-height: 26px;
  color: ${({ theme }) => theme.colors.fontSecondary};
`

export const ClientProfileFormAlertContainer = styled.div`
  margin-top: 9px;
`

export const ClientProfileFormAvatar = styled.img`
  width: 116px;
  height: 116px;
  border-radius: 50%;
`

export const ClientProfileFormDataContainer = styled.div`
  width: 360px;
`
export const ClientProfileFormDataFlex = styled.div`
  display: flex;
`

export const ClientProfileFormBalanceContainer = styled.div`
  display: flex;
  margin-top: 33px;
  border-top: 1px solid ${({ theme }) => theme.colors.borderSecondary};
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderSecondary};
`

export const ClientProfileFormBalanceContent = styled.div`
  display: flex;
  align-items: center;
  padding: 17px 39px;
`
export const ClientProfileFormBalanceTitle = styled.p`
  margin: 0;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.fontSecondary};
`

export const ClientProfileFormBalance = styled.span`
  margin: 0;
  margin-left: 15px;
  font-size: 16px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.fontSecondary};
`

export const ClientProfileFormVerticalDivider = styled.div`
  border-left: 1px solid ${({ theme }) => theme.colors.borderSecondary};
`

export const ClientProfileFormAddPayment = styled.div`
  display: flex;
  align-items: center;
  padding: 16px 28px;
`

export const ClientProfileFormAddPaymentButton = Button;
